import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FinanceReports } from 'src/app/shared/models/finance';
import { CommonService } from 'src/app/shared/services/common.service';
import { FinanceService } from 'src/app/shared/services/finance.service';

@Component({
  selector: 'app-finance-report',
  templateUrl: './finance-report.component.html',
  styleUrls: ['./finance-report.component.scss']
})
export class FinanceReportComponent implements OnInit {
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public startDate: string;
  public endDate: string;
  public type: string = "asset";
  public financeReports: FinanceReports[]=[];
  public types: string[] = [];


  constructor(
    private commonService: CommonService,
    private datePipe: DatePipe,
    private financeService: FinanceService
  ) { }

  ngOnInit(): void {
    this.types = this.commonService.getTypes();
    this.startDate = this.datePipe.transform(this.commonService.adjustDateByDays(-30), 'yyyy-MM-dd');
    this.endDate = this.datePipe.transform(this.commonService.adjustDateByDays(30), 'yyyy-MM-dd');
    this.getFinanceReport();  
  }

  public getFinanceReport(clear: boolean = true) {
      if (clear) {
        this.isLoading = true;
        this.financeReports = [];
      }
      if (!this.startDate || !this.endDate) {
        this.commonService.setToastr(500, "Both \"From Date\" and \"To Date\" are required to proceed.")
        return;
      }
      const startDate = this.datePipe.transform(this.startDate, 'dd-MM-yyyy');
      const endDate = this.datePipe.transform(this.endDate, 'dd-MM-yyyy');
      this.financeService.getFinanceReport(this.type, startDate, endDate).subscribe({
        next: (financeReports: FinanceReports[]) => {
          this.financeReports = financeReports.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } 
  }


